var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 40,
    viewBox: "0 0 62 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 40,
    rx: 2,
    fill: "#F2F2F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_357_2148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.1417 17.8209C31.1206 19.4859 32.6255 20.415 33.7592 20.9674C34.9239 21.5341 35.3151 21.8976 35.3105 22.4045C35.3018 23.1802 34.3814 23.5225 33.5202 23.5358C32.0176 23.5591 31.1439 23.1301 30.4493 22.8057L29.908 25.3386C30.6049 25.6597 31.8953 25.9397 33.2333 25.952C36.3743 25.952 38.4292 24.4016 38.4403 21.9977C38.4526 18.9468 34.2204 18.7779 34.2493 17.4142C34.2593 17.0007 34.6538 16.5595 35.5184 16.4473C35.9464 16.3906 37.1277 16.3473 38.4671 16.964L38.9928 14.5134C38.2725 14.2512 37.3467 14 36.1942 14C33.2378 14 31.1585 15.5716 31.1417 17.8209ZM44.044 14.2111C43.4705 14.2111 42.9872 14.5457 42.7715 15.0591L38.2848 25.772H41.4234L42.048 24.0459H45.8834L46.2457 25.772H49.012L46.598 14.2111H44.044ZM44.4831 17.3341L45.3889 21.6754H42.9082L44.4831 17.3341ZM27.3363 14.2113L24.8623 25.7719H27.8532L30.326 14.211H27.3363M22.9118 14.211L19.7987 22.0799L18.5394 15.3893C18.3917 14.6424 17.8081 14.2111 17.1601 14.2111H12.0713L12 14.5468C13.0447 14.7735 14.2317 15.1392 14.9508 15.5304C15.3909 15.7694 15.5164 15.9783 15.661 16.5462L18.0461 25.772H21.2067L26.0524 14.2111H22.9118",
    fill: "url(#paint0_linear_357_2148)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_357_2148",
    x1: 29.0159,
    y1: 26.1918,
    x2: 29.3619,
    y2: 13.9169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#254AA5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_357_2148"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.012,
    height: 12,
    fill: "white",
    transform: "translate(12 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.5b3f61684c2f5e0bc1bfa19f1a227eeb.svg";
export { ForwardRef as ReactComponent };